import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import OperatorParamsLoader from "~/operatorApplication/ts/service/OperatorParamsLoader";

export default class CheckToken extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "checkToken";
    }

    public receive(payload: CometOperatorApplication.ChangeMessageStatusCometMessageOpenApiModel): void {
        OperatorParamsLoader.reload(true, "checkToken");
    }

}